import React from 'react';
import H3Text from '@Uilib/h3Text';
import Attachment from '@Components/Common/Attachment';

const ViewIncomingPaymentFooter = ({
  fileList,
  getAttachmentByIdLoading,
  updateAttachmentLoading,
  selectedPaymentOutgoing,
  handleFileChange,
  MONEY
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '20px',
      }}
    >
      <Attachment
        fileList={fileList}
        disableCase={getAttachmentByIdLoading || updateAttachmentLoading}
        labelClassName="orgFormLabel"
        inputClassName=""
        containerClassName="view__grn-attachment"
        handleFileChange={(value) => handleFileChange(value)}
      />
      <div className="payment-total__wrapper" style={{ marginTop: '-20px' }}>
        {selectedPaymentOutgoing && (
          <div className="payment-total_quote-totals">
            <div className="payment-total_field">
              <H3Text text="Total Payment" className="payment-total_field-name" />
              <H3Text
                text={MONEY(selectedPaymentOutgoing?.amount || 0)}
                className="payment-total_field-value"
              />
            </div>
            <div className="payment-total_field">
              <H3Text text="Used Amount" className="payment-total_field-name" />
              <H3Text
                text={MONEY(
                  (selectedPaymentOutgoing?.amount - selectedPaymentOutgoing?.unused_amount) || 0
                )}
                className="payment-total_field-value"
              />
            </div>
            <div className="payment-total_field payment-total_field-total">
              <H3Text text="Amount in Excess" className="payment-total_field-name" />
              <H3Text
                text={MONEY(selectedPaymentOutgoing?.unused_amount || 0)}
                className="payment-total_field-value"
              />
            </div>
          </div>
        )}
        {selectedPaymentOutgoing?.remarks && (
          <div className="view__payment-tc">
            <H3Text text="Remark" className="view__payment-tc-title" />
            <H3Text
              text={selectedPaymentOutgoing?.remarks}
              className="view__payment-tc-body"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewIncomingPaymentFooter;
